(
    function (skyward, $, undefined)
    {
        skyward.demographics = skyward.demographics || {};

        var init = function ()
        {
            var nameMergeScreen = this.find("#NameMergeNameSelect");
            if (nameMergeScreen.length !== 0)
            {
                getAndSetNameMergeScreenInfo(nameMergeScreen);
            }
        };

        skyward.window.registerLoadDOMCallback(init);

        var getAndSetNameMergeScreenInfo = function (informationDiv)
        {
            var mergeFromNameID = skyward.controls.getValue('#MergeFromNameID');
            var mergeToNameID = skyward.controls.getValue('#MergeToNameID');
            var checkboxDatas = [];

            if (mergeFromNameID === "" || mergeToNameID === "")
            {
                return;
            }

            var checkboxes = informationDiv.find(':checkbox').each(function ()
            {
                checkboxDatas.push({ checkboxID: this.id, value: skyward.controls.getValue(this) });
            });

            $.when($("#MergeFromNameID_value").change()).done(function ()
            {
                $.each(checkboxDatas, function (i, val)
                {
                    if (val.value)
                    {
                        skyward.controls.setValue($('#' + val.checkboxID), true);
                    }
                });
            });
        };

        skyward.demographics.newEmergencyContactTab = function ()
        {
            var parentBrowse = $(this).parents('#EmergencyContactNameLookupBrowse')[0];
            if (parentBrowse.hasAttribute("data-isstudentec"))
            {
                var isStudentEC = parentBrowse.attributes["data-isstudentec"].value;
                if (isStudentEC == "True")
                {
                    if (parentBrowse.hasAttribute("data-studentid"))
                    {
                        skyward.window.loadContent('popout', "Demographics", "EmergencyContact", "StudentProfile", parentBrowse.attributes["data-studentid"].value);
                    }
                }
                if (isStudentEC == "False")
                {
                    if (parentBrowse.hasAttribute("data-employeeid"))
                    {
                        skyward.window.loadContent('popout', "Employee", "EmergencyContact", "EmployeeProfile", parentBrowse.attributes["data-employeeid"].value);
                    }
                }
            }
        };

        function resetMessage(field, defaultSubject, defaultContent)
        {
            skyward.controls.setValue($('#' + field + 'Subject'), defaultSubject, false);
            skyward.controls.setValue($('#' + field + 'Content'), defaultContent, false);
        };

        //Changes here need to be replicated in Skyward.Business.Demographics.ConfigSystem as well.
        const resetACHAccountModificationMessage = function ()
        {
            skyward.messagecenter.resetTemplate(
                this,
                'ACH Account Modified',
                'An ACH Account linked to {Name.FullNameFL} has been modified. If you were not expecting this change, please reach out to your Human Resources representative.');
        };

        // Event handlers
        var events =
        {
            "newEmergencyContactTab": skyward.demographics.newEmergencyContactTab,
            "updateForIsSingleLegalNameOption": skyward.demographics.updateForIsSingleLegalNameOption,
            resetACHAccountModificationMessage,
        };
        skyward.events.registerEvents("demographics", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);